export const GET_HOURS_CSV = 'SAGA/GET_HOURS_CSV';

export const getPayrollCsv = (cleanerId, date) => {
  return {
    type: GET_HOURS_CSV,
    date,
  };
};
